export default function InputSelect ({inputLabel, inputType, inputId, inputName, inputValue, inputOnChange, inputStyle, selectName, selectId, selectValue, selectOnChange, selectStyle, selectOptions}) {
    return (
        <>                                    
            <label>{inputLabel}</label>
            <div className='input-select'>
                <input type={inputType} name={inputName} id={inputId} value={inputValue} onChange={inputOnChange} style={inputStyle} />
                <select name={selectName} id={selectId} value={selectValue} onChange={selectOnChange} style={selectStyle}>
                    {
                        selectOptions.map((option) => 
                            <option value={option.value}>{option.label}</option>
                        )
                    }
                </select>
            </div>     
        </>
    )
}